import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Form, Select } from "antd";
import React from "react";
import { CommunicationChannelEnum } from "./api/Representation";
import { useAppSelector } from "../../../../store";
import { selectedTenantSettingsSelector } from "../../../../store/slice/auth";
const ConsignmentCommunicationChannelsFormItems = () => {
    const selectedTenantSettings = useAppSelector(selectedTenantSettingsSelector);
    const deliveryNotifications = selectedTenantSettings?.deliveryNotifications;
    let channels = [];
    if (deliveryNotifications?.enabled) {
        if (deliveryNotifications.sendSMS) {
            channels.push(CommunicationChannelEnum.SMS);
        }
        if (deliveryNotifications.sendEmail) {
            channels.push(CommunicationChannelEnum.EMAIL);
        }
    }
    const options = channels.map(channel => (_jsx(Select.Option, { value: channel, children: channel }, channel)));
    return (_jsxs(_Fragment, { children: [_jsx(Form.Item, { name: "scheduledCommunicationChannels", label: "Scheduled", children: _jsx(Select, { mode: "multiple", allowClear: true, style: { width: '100%' }, value: channels, children: options }) }), _jsx(Form.Item, { name: "startedCommunicationChannels", label: "Started", children: _jsx(Select, { mode: "multiple", allowClear: true, style: { width: '100%' }, value: channels, children: options }) }), _jsx(Form.Item, { name: "completedCommunicationChannels", label: "Completed", children: _jsx(Select, { mode: "multiple", allowClear: true, style: { width: '100%' }, value: channels, children: options }) })] }));
};
export default ConsignmentCommunicationChannelsFormItems;
